import { neutralPalette } from "../fast-design-system";
import { colorRecipeFactory, swatchFamilyToSwatchRecipeFactory, SwatchFamilyType, } from "./common";
import { accessibleAlgorithm } from "./accessible-recipe";
function neutralForegroundHintAlgorithm(targetContrast) {
    return accessibleAlgorithm(neutralPalette, targetContrast, 0, 0, 0, 0);
}
/**
 * Hint text for normal sized text, less than 18pt normal weight
 * @internal
 */
export const neutralForegroundHint = swatchFamilyToSwatchRecipeFactory(SwatchFamilyType.rest, colorRecipeFactory(neutralForegroundHintAlgorithm(4.5)));
/**
 * Hint text for large sized text, greater than 18pt or 16pt and bold
 * @internal
 */
export const neutralForegroundHintLarge = swatchFamilyToSwatchRecipeFactory(SwatchFamilyType.rest, colorRecipeFactory(neutralForegroundHintAlgorithm(3)));
